<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Bordro Türü</label>
            <v-select-list :options="bordroList" label="name" placeholder="Bordro Türü  " v-model="type"></v-select-list>
        </div>
        <div class="col-12 mb-1 ">
            <label class="form-label">Ay</label>
            <select class="form-control" v-model="value.Month">
                <option :value="null" v-if="value.Month == null">Seçiniz</option>
                <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
            </select>
        </div>
        <div class="col-12 mb-1 ">
            <label class="form-label">Yıl</label>
            <select class="form-control" v-model="value.Year">
                <option :value="null" v-if="value.Year == null">Seçiniz</option>
                <option v-for="y in years" :key="y" :value="y">{{y}}</option>
            </select>
        </div>
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <v-file-uploader :accept="['xlsx','rtf']" :value="value" value-parameter="File"></v-file-uploader>
        </div>
        <div class="col-12 mt-1 mb-1" v-if="value.Type == 0">
            <b-form-checkbox v-model="value.Kesinti">Kesinti</b-form-checkbox> 
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
    components:{
        VFileUploader,
        BFormCheckbox
    },
    props:{
        value:Object,
        bordroList:Array,
        months:{
            type:Array,
            default:()=>([])
        }
    },
    data(){
        return {
            years:[]
        }
    },
    mounted(){
        this.configureYears()
    },
    methods:{
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    },
    computed:{
        type:{
            get:function(){
                return this.bordroList.find(i=>i.value==this.value.Type)
            },
            set:function(value){
                this.value.Type = value?.value != null ? value.value : null
            }
        },
    }
}
</script>